import { API } from '@/config/api';
import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Droplet } from 'lucide-react';
import { toast } from 'sonner';


export default function WaterIntake() {
  const [todayTotal, setTodayTotal] = useState(0);
  const [amount, setAmount] = useState(250);

  useEffect(() => {
    fetchToday();
  }, []);

  const fetchToday = async () => {
    try {
      const response = await fetch(`${API}/tracking/water/today`, {
        credentials: 'include'
      });
      if (response.ok) {
        const data = await response.json();
        setTodayTotal(data.total_ml);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
    }
  };

  const handleLog = async (ml) => {
    try {
      const response = await fetch(`${API}/tracking/water?water_ml=${ml}`, {
        method: 'POST',
        credentials: 'include'
      });

      if (response.ok) {
        toast.success(`Logged ${ml}ml of water`);
        fetchToday();
      }
    } catch (error) {
      toast.error('Failed to log water');
    }
  };

  const goal = 2000;
  const percentage = Math.min((todayTotal / goal) * 100, 100);

  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-8">Water Intake</h1>

      <Card className="p-8 glass-card text-center mb-6">
        <Droplet className="h-16 w-16 mx-auto mb-4 text-info" />
        <h2 className="text-5xl font-bold mb-2">{todayTotal}ml</h2>
        <p className="text-muted-foreground mb-4">of {goal}ml goal</p>
        
        <div className="w-full bg-secondary rounded-full h-4 mb-6">
          <div
            className="bg-info h-4 rounded-full transition-all duration-500"
            style={{ width: `${percentage}%` }}
          />
        </div>

        <div className="grid grid-cols-3 gap-3 mb-4">
          <Button onClick={() => handleLog(250)} variant="outline">+ 250ml</Button>
          <Button onClick={() => handleLog(500)} variant="outline">+ 500ml</Button>
          <Button onClick={() => handleLog(1000)} variant="outline">+ 1L</Button>
        </div>

        <div className="flex gap-2">
          <Input
            type="number"
            value={amount}
            onChange={(e) => setAmount(Number(e.target.value))}
            placeholder="Custom amount"
          />
          <Button onClick={() => handleLog(amount)}>Log</Button>
        </div>
      </Card>
    </div>
  );
}
